import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import parse from 'date-fns/parse'
import format from 'date-fns/format'
import { Header } from 'semantic-ui-react'

import styles from './article-preview.module.css'

export default ({ article }) => (
  <div className={styles.preview}>
    <Link to={`/${format(parse(article.publishDate), 'YYYY/MM')}/${article.slug}`}>
      <Img alt="" fluid={article.heroImage.fluid}/>
      <Header as={'h3'} className={styles.previewTitle}>
        {article.title}
      </Header>
      <small>{format(parse(article.publishDate), 'MMMM Do, YYYY')}</small>
      <p
        dangerouslySetInnerHTML={{
          __html: article.description.childMarkdownRemark.html,
        }}
      />
    </Link>
  </div>
)
